import get from 'lodash/get';

export const selectUseMarkdown = (state) => get(state, 'settings.report.useMarkdown', false);

export const selectBorderWidth = (state) => get(state, 'settings.report.borderWidth', 0);
